/* eslint-disable camelcase */
import {
  ENDPOINT_CARTS,
  ENDPOINT_ITEMS,
  ENDPOINT_ROOT,
} from '@/common/constants';
import axiosAuth from '@/common/interceptors/axios.AuthInterceptor';

const patchCartItem = ({
  cartId,
  id,
  quantity,
  is_selected,
  is_diff_selected,
}) => {
  const params = { quantity, is_selected, is_diff_selected };

  return axiosAuth
    .patch(
      `${ENDPOINT_ROOT}/${ENDPOINT_CARTS}/${cartId}/${ENDPOINT_ITEMS}/${id}`,
      params,
    )
    .then((res) => res.data);
};

export default patchCartItem;
